<template>
  <div class="fondo">
    <landing />
    <contador />
    <servicios />
    <cloud />
    <eko />
  </div>
</template>


<script>
// @ is an alias to /src
import Eko from "@/components/section/index/Eko.vue";
import Landing from "@/components/section/index/Landing.vue";
import Servicios from "@/components/section/index/Servicios.vue";
import Contador from "@/components/section/index/Contador.vue";
import Cloud from "@/components/section/index/Cloud.vue";

export default {
  name: "index",
  components: {
    Landing,
    Eko,
    Servicios,
    Contador,
    Cloud,
  },
};
</script>

<style scoped>
/* .fondo{
background: rgb(170,188,212);
background: -moz-linear-gradient(0deg, rgba(170,188,212,1) 0%, rgba(210,221,236,1) 49%, rgba(227,235,246,1) 100%);
background: -webkit-linear-gradient(0deg, rgba(170,188,212,1) 0%, rgba(210,221,236,1) 49%, rgba(227,235,246,1) 100%);
background: linear-gradient(0deg, rgba(170,188,212,1) 0%, rgba(210,221,236,1) 49%, rgba(227,235,246,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#aabcd4",endColorstr="#e3ebf6",GradientType=1);
} */

.mouse {
  width: 1.5rem;
  height: 3rem;
  border: 2px solid white;
  border-radius: 2rem;
  margin-bottom: 0.5rem;
}

.mouse span {
  width: 0.5rem;
  height: 0.5rem;
  background-color: white;
  display: block;
  border-radius: 50%;
  margin: auto;
  animation: move-wheel 1s linear infinite;
}

@keyframes move-wheel {
  0% {
    opacity: 0;
    transform: translateY(0rem);
  }
  100% {
    opacity: 1;
    transform: translateY(2rem);
  }
}
</style>